export default __webpack_public_path__ + "static/media/Beppe7.59866be3.jpg";